// @ts-strict-ignore
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component, EventEmitter,
  HostBinding,
  Input,
  OnInit, Output,
  ViewChild
} from '@angular/core';
import { ExpandableAreaComponent } from 'ids-enterprise-ng';
import { CdkDrag, CdkDragDrop, CdkDropList } from '@angular/cdk/drag-drop';

@Component({
  selector: 'lm-columnar-adhoc-report-dimensions',
  standalone: false,
  templateUrl: './lm-columnar-adhoc-report-dimensions.component.html',
  styleUrls: ['./lm-columnar-adhoc-report-dimensions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ ]
})
export class LMColumnarAdhocReportDimensionsComponent implements OnInit{
  @HostBinding('attr.data-automation-id') automationId = 'lm-columnar-adhoc-report-dimensions';
  @ViewChild(ExpandableAreaComponent) expandableArea: ExpandableAreaComponent | undefined;

  @Input() spec: LMListSpec;
  @Input() chartName: string;
  @Input() get facadeDimensions(): Array<LMFacadeField> {
    return this._facadeDimensions;
  }
  set facadeDimensions(value: Array<LMFacadeField>) {
    this._facadeDimensions = value;
    this.initializeAvailableDimensions();
  }

  @Output() dimensionsUpdated = new EventEmitter<LMAdhocAggField[]>();

  public readonly DIMENSIONS_LIST = 'current-dimensions';

  public dimensionsHeader = Soho.Locale.translate('Dimensions');
  public availableDimensionsHeader = Soho.Locale.translate('AvailableDimensions');

  public selectedExpandableOpen = true; // Expandable Section Toggle

  public chartSpec: LMChartSpec;
  private _facadeDimensions: Array<LMFacadeField> = []; // Private input
  public dimensions: LMAdhocAggField[] = []; // Dimensions in the chart definition
  public availableDimensions: Array<LMFacadeField> = [];

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
  ) { }

  ngOnInit(): void {
    this.chartSpec = this.spec.busListSpec.charts.find((c: LMChartSpec) => c.id === this.chartName);
    if (!this.chartSpec) {
      //Print error
      return;
    }
    this.dimensions = this.chartSpec.aggFields.filter((field: LMAggField) => !field.isTotal) as LMAdhocAggField[] ;
  }

  private initializeAvailableDimensions() {
    if (!this.facadeDimensions || !this.dimensions)
      return;
    this.facadeDimensions.forEach(f => {
      // Dimensions can only be added once
      if (!this.dimensions.some(d => d.fieldId === f.fieldId)) {
        this.availableDimensions.push(f);
      }
    });
    this.availableDimensions.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0));
    this.changeDetectorRef.markForCheck();
  }

  canDrop = (drag: CdkDrag, drop: CdkDropList): boolean => {
    return !!drag.dropContainer.data.includes(this.DIMENSIONS_LIST);
  };

  drop(event: CdkDragDrop<string[]>) {
    if (event.previousContainer.data.includes(this.DIMENSIONS_LIST)) {
      this.reorderDisplayField(event.currentIndex, event.previousIndex, event.item.data);
    }
  }

  public reorderDisplayField(newIndex: number, oldIndex: number, data: any) {
    // Reordering dimensions
    if (newIndex !== oldIndex && newIndex >= 0 && newIndex < this.dimensions.length) {
      const field = this.dimensions.splice(oldIndex, 1)[0];
      this.dimensions.splice(newIndex, 0, field);

      this.dimensionsUpdated.emit(this.dimensions);
      this.changeDetectorRef.markForCheck();
    }
  }

  public setDimension(i: number) {
    // Dimension property sheet
    // Evaluate the need for it, especially for labels
  }

  public addDimension(i: number) {
    const dimensionToAdd = this.availableDimensions[i];
    this.dimensions.push({
      index: this.dimensions.length,
      added: true,
      columnId: dimensionToAdd.fieldId,
      filterFieldId: dimensionToAdd.fieldId,
      fieldId: dimensionToAdd.fieldId,
      isDefaultSort: false,
      label: { resourceValue: dimensionToAdd.name },
      isTotal: false,
      type: dimensionToAdd.uiFieldSpec.fieldType
    });

    this.dimensionsUpdated.emit(this.dimensions);
    this.changeDetectorRef.markForCheck();
  }

  public removeDimension(index: number) {
    this.dimensions.splice(index, 1);
    // What to do with index? Is an update required?
    // this.dimensions.forEach((d, i) => d.index = i);

    this.dimensionsUpdated.emit(this.dimensions);
    this.changeDetectorRef.markForCheck();
  }

  toggleHeaders($event: Event): void {
    $event.stopPropagation();
    $event.stopImmediatePropagation();
    if (this.expandableArea) {
      if (this.selectedExpandableOpen) {
        this.expandableArea.close();
        this.selectedExpandableOpen = false;
      } else {
        this.expandableArea.open();
        this.selectedExpandableOpen = true;
      }
    }
  }
}
